import { render, staticRenderFns } from "./VersionInformationDialog.vue?vue&type=template&id=82eb3ba4&scoped=true&"
import script from "./VersionInformationDialog.vue?vue&type=script&lang=ts&"
export * from "./VersionInformationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VersionInformationDialog.vue?vue&type=style&index=0&id=82eb3ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eb3ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDialog,VDivider,VIcon,VSpacer,VTimeline,VTimelineItem})
